import {
  laptopMaxXL,
  laptopMediumMax,
  laptopMinXL,
  mobileXLargeMax,
  mobileXLargeMin,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import MmcwLogo from '@propertypal/shared/src/resources/logos/millar-mccall-wylie-logo.svg';
import styled, { css } from 'styled-components';
import { Container as Button } from '../buttons/Button.style';
import ErrorMessage from '../inputs/ValidationError.style';
import { MAX_WIDTH } from '../layout/PageWrapper.style';
import { SubHeading, Text } from '../typography';

export const Container = styled.section`
  margin: 50px auto;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  padding: 0px 30px;

  @media (${laptopMediumMax}) {
    padding: 0px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 4px;
  border: solid 4px ${({ theme }) => theme.backgroundLightest};
`;

const contentContainer = css`
  padding: 40px;

  @media (${laptopMediumMax}) {
    padding: 20px;
  }
`;

export const LegalContainer = styled.div`
  ${contentContainer}
`;

export const LegalTitle = styled(SubHeading)`
  font-size: 30px;
`;

export const LegalTitleContainer = styled.div`
  @media (${mobileXLargeMax}) {
    max-width: 150px;

    ${LegalTitle} {
      font-size: 24px;
    }
  }
`;

export const ContactContainer = styled.div`
  ${contentContainer};
  padding-top: 55px;
  padding-bottom: 55px;
  background-color: ${({ theme }) => theme.primaryTranslucent};
`;

export const ContactTitle = styled(SubHeading)`
  font-size: 28px;
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 30px;
  width: 100px;

  @media (${mobileXLargeMax}) {
    width: 80px;
  }
`;

export const Logo = styled(MmcwLogo)`
  width: 100%;
`;

export const LegalDetailsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;

  @media (${laptopMaxXL}) {
    flex-direction: column;
    margin-top: 60px;
  }

  @media (${mobileXLargeMax}) {
    margin-top: 20px;
  }
`;

export const LegalDetails = styled.div`
  flex-basis: 50%;
  padding-right: 10px;

  @media (${mobileXLargeMax}) {
    ${Button} {
      max-width: none;
    }
  }
`;

export const LegalDetailsSubtitle = styled(Text)`
  @media (${mobileXLargeMax}) {
    font-size: 20px;
    line-height: 1.4;
    margin-bottom: 20px;
  }
`;

export const LegalAbout = styled.div`
  flex-basis: 50%;

  @media (${mobileXLargeMin}) {
    padding-left: 10px;
  }
`;

export const LegalAboutTitle = styled(Text)`
  @media (${mobileXLargeMax}) {
    font-size: 18px;
  }
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.backgroundLightest};

  @media (${laptopMinXL}) {
    width: 4px;
    margin: 0px 40px;
  }

  @media (${laptopMaxXL}) {
    height: 4px;
    width: 100%;
    margin: 30px 0px;
  }
`;

export const AboutList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  & > :not(:first-child) {
    margin-top: 22px;
  }
`;

export const AboutListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (${mobileXLargeMax}) {
    ${Text} {
      font-size: 16px;
    }
  }
`;

export const ModalContent = styled.div`
  padding: 30px;

  @media (${tabletMax}) {
    padding: 15px 10px;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;

  input::placeholder {
    color: ${({ theme }) => theme.backgroundMid};
  }

  @media (${tabletMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const ConsentContainer = styled.div`
  width: 100%;
  @media (min-width: 769px) {
    max-width: 75%;
  }
`;

export const ContactSentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  @media (${laptopMaxXL}) {
    flex-direction: column;
    text-align: center;
  }
`;

export const VisitWebsite = styled.a`
  width: 100%;
  max-width: 320px;

  button {
    border-radius: 8px;
  }
`;

export const CheckboxContainer = styled.div`
  margin-top: 15px;

  ${ErrorMessage} {
    margin-top: 10px;
  }
`;
